// import { mapActions, mapState } from 'vuex'
// import * as XLSX from 'xlsx/xlsx.mjs'
// import store from '@/store'
// import axios from 'axios'
// import router from '@/router/'
import PanelEntregaDiaria from '@/components/Layout/Panel_entrega_diaria/PanelEntregaDiariaView.vue'
import SideBarView from '@/components/Layout/Menu/SideBar/SideBarView.vue'
import WebsocketView from '@/components/Layout/Menu/Websocket/WebsocketView.vue'
// import BarChart from '@/components/Layout/Menu/Graficos/BarChart/BarChart.vue'
// import store from '@/store'

export default {
  name: 'MenuView',
  components: {
    PanelEntregaDiaria,
    SideBarView,
    WebsocketView
  },
  props: {
  },
  data: function () {
    return {
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    // ...mapActions('AdministradorFlota', [
    //   'getTransportes', 'getConductores', 'getAyudantes', 'getCamiones'
    // ])
  },
  computed: {
    // ...mapState('AdministradorFlota', ['transportes'])
  }
}
